import {
  SUBMITTAL_PACKAGE_STATUS,
  SUBMITTAL_REGISTRY_STATUS,
} from '@app/store/submittals/submittals.types';
import { RFI_STATUS } from '@app/store/rfis/rfi.types';
import { COR_STATUS, PCCO_STATUS } from '@app/store/prime-commitments/prime-commitments.types';
import { PCO_STATUS } from '@app/store/pco/pco.types';

export type DefaultDropdownOption = {
  label: string;
  value: any;
};

export enum PROGRESS_BAR_PERCENT_COLORS {
  OVER_COMMITTED, // color red light
  COMPLETE, //  color accent
  DEFAULT, // color secondary
}

export const CAPEX_ID = 1;
export const OPEX_ID = 2;

export type AllPossibleStatusesType =
  | PCO_STATUS
  | COR_STATUS
  | PCCO_STATUS
  | RFI_STATUS
  | SUBMITTAL_REGISTRY_STATUS
  | SUBMITTAL_PACKAGE_STATUS;

export const ALL_POSSIBLE_STATUSES: AllPossibleStatusesType[] = [
  ...Object.values(PCO_STATUS),
  ...Object.values(COR_STATUS),
  ...Object.values(PCCO_STATUS),
  ...Object.values(RFI_STATUS),
  ...Object.values(SUBMITTAL_PACKAGE_STATUS),
];
